import {
  useEffect,
  useState,
} from 'react'

import {
  useLocation,
  useNavigate,
} from 'react-router-dom'

import removeFlowToken from './removeFlowToken'


/**
 * Reads the one-time flow token from the URL fragment and removes it from the
 * address.
 *
 * Removed so that a reload cannot send the spent token again and nothing that
 * later reads the address can see it. Replaced rather than pushed, keeping the
 * router's state, so that going back does not return to it either. Anything
 * else the fragment carries stays.
 *
 * @returns {String|null} the token, or `null` when the page was loaded without
 *   one
 */
export default function useFlowToken() {
  const {
    hash,
    pathname,
    search,
    state,
  } = useLocation()

  const navigate = useNavigate()

  // Kept from the first render, because the address stops carrying the token
  // as soon as it is removed.
  const [flowToken] = useState(() => removeFlowToken(hash).flowToken)

  useEffect(() => {
    const removal = removeFlowToken(hash)

    // The address changes once the token is removed, which runs this again
    // with nothing left to remove.
    if ( !removal.flowToken ) {
      return
    }

    navigate({
      hash: removal.hash,
      pathname,
      search,
    }, {
      replace: true,
      state,
    })
  }, [hash, navigate, pathname, search, state])

  return flowToken
}
